import Modal from 'Shared/components/Modal/Modal'
import SubscriptionTopicsSelect from 'Shared/components/SubscriptionTopicsSelect'
import CheckboxField from 'Shared/components/CheckboxField'
import Select from 'react-select'
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'

export default function UpdateSubscriptionModal({ open, onCancel, onConfirm }) {
  const [subscriptionStatus, setSubscriptionStatus] = useState(false)
  const [topic, setTopic] = useState('default')
  const [kind, setKind] = useState('phone')
  const [title, setTitle] = useState('phone calls')

  const isNationalAdminUser = window.ENV.ORGANISATION_NAME === 'National' && window.ENV.CURRENT_USER_PERMISSIONS.includes('manage_admin')
  const [allOrganisations, setAllOrganisations] = useState(!isNationalAdminUser)
  const [organisationKind, setOrganisationKind] = useState(null)

  const subscribedOptions = [
    { value: true, label: 'Subscribed' },
    { value: false, label: 'Unsubscribed' }
  ]

  const organisationKinds = [
    { label: 'National', value: 'national' },
    ...window.ENV.ORGANISATION_KINDS.map(kind => ({
      label: kind.label,
      value: kind.external_type
    }))
  ]

  const setKindAndTopic = (value) => {
    const [newKind, newTopic] = value.split(':')
    setKind(newKind)
    setTopic(newTopic)
  }

  const handleConfirm = () => {
    const parameters = {
      subscriptionStatus,
      kind,
      topic
    }

    if (!allOrganisations) {
      parameters.organisationKind = organisationKind
    }
    
    return onConfirm(parameters)
  }

  return (
    <Modal
      open={open}
      title="Update a subscription for this audience"
      onCancel={onCancel}
    >
      <div className="row">
        <div className="field">
          <label className="bold margin-bottom">Subscription to update</label>
          <SubscriptionTopicsSelect
            onChange={(v) => {
              setKindAndTopic(v.value)
              setTitle(v.label === 'Phone' ? 'phone calls' : v.label === 'Email' ? 'emails' : v.label === 'SMS' ? 'SMS' : 'WhatsApp messages')
            }}
            value={`${kind}:${topic}`}
          />
        </div>
      </div>

      <div className="row margin-top">
        <div className="field">
          <label className="bold margin-bottom">Subscription Status</label>
          <Select
            options={subscribedOptions}
            value={subscribedOptions.find(option => option.value === subscriptionStatus)}
            onChange={(selectedOption) => setSubscriptionStatus(selectedOption.value)}
            classNamePrefix="subscription-topics-select"
            styles={{
              container: (baseStyles) => ({
                ...baseStyles,
                width: '200px',
              }),
            }}
          />
        </div>
      </div>

      {isNationalAdminUser && (
        <>
          <div className="row margin-top double">
            <div className="field">
              <CheckboxField
                label="All organisations"
                value={allOrganisations}
                className="bold"
                onChange={(checked) => setAllOrganisations(checked)}
              />
            </div>
          </div>

          {!allOrganisations && (
            <div className="row margin-top half">
              <div className="field">
                <label className="bold margin-bottom">Organisation Type</label>
                <Select
                  menuPlacement="top"
                  maxMenuHeight={300}
                  options={organisationKinds}
                  value={organisationKinds.find(option => option.value === organisationKind)}
                  onChange={(selectedOption) => setOrganisationKind(selectedOption.value)}
                  classNamePrefix="subscription-topics-select"
                  styles={{
                    container: (baseStyles) => ({
                      ...baseStyles,
                      width: '200px',
                    }),
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}

      <p className="bold margin-top double">
        This will {subscriptionStatus ? 'subscribe' : 'unsubscribe'} everyone in the audience {subscriptionStatus ? 'to receive' : 'from receiving'} {title}.
      </p>

      <div className="row">
        <ServerWaitButton
          className="button primary margin-top update-subscription-button"
          onClick={handleConfirm}
          disabled={!allOrganisations && !organisationKind}
        >
          Confirm
        </ServerWaitButton>
      </div>
    </Modal>
  )
}
